import axios from '../http'

function query(data) {
    return axios.post('/event/crewNumber/query', data);
}

function get(id) {
    return axios.get('/event/crewNumber/get?id=' + id);
}

function update(data) {
    return axios.post('/event/crewNumber/update', data);
}

export default {
    query,
    get,
    update
}